import { render, staticRenderFns } from "./permissionrulelist.vue?vue&type=template&id=081fe628&scoped=true"
import script from "./permissionrulelist.vue?vue&type=script&lang=js"
export * from "./permissionrulelist.vue?vue&type=script&lang=js"
import style0 from "./permissionrulelist.vue?vue&type=style&index=0&id=081fe628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fe628",
  null
  
)

export default component.exports